$(function() {
	$(function() {
		if(document.getElementsByTagName('body')[0].classList.contains('pgCategory') && $('#cat-list').length > 0) {
			var $grid = $('#cat-list').imagesLoaded( function() {
				$grid.masonry({
					itemSelector: '.cat-item',
					columnWidth: '.grid-sizer',
					percentPosition: true,
					originLeft: false
				});
			});
		}
	}); 
});   